import './pass-product.scss';
